// Mock data for Clinical Psychology website
export const psychologistData = {
  name: "Manish Pacher",
  title: "Clinical Psychologist & Family Therapist",
  subtitle: "Helping Couples, Families, and Individuals Reconnect and Thrive",
  experience: "20+ Years of Experience",
  description: "I help couples and families through evidence-based, compassionate guidance to improve their communication, resolve conflicts, and deepen connection.",
  
  contact: {
    phone: "+91 9167250014",
    email: "manish.pacher@gmail.com",
    whatsapp: "+91 9167250014",
    locations: [
      "Lokhandwala Complex, Andheri West",
      "Andheri East"
    ],
    schedules: {
      weekdays: "Monday - Saturday: 7:00 PM - 9:00 PM",
      sunday: "Sunday: 2:00 PM - 9:00 PM"
    }
  },

  credentials: [
    "Clinical Psychologist & Family Therapist",
    "Consultant Psychologist at Bhaktivedanta Hospital",
    "Psychiatry Ward Officer at PV Doshi Hospital",
    "Stanford University School of Medicine Certified",
    "CBT Certified (under Albert Ellis Supervisor USA)",
    "PDG School Counselling (Symbiosis, Pune)",
    "Bach Flower & Yoga Therapist",
    "20 Years Experience in Community Counselling"
  ],

  specializations: [
    "Identifying Early Signs of Psychosis in Adolescents and Young Adults",
    "Identifying and Responding to Developmental Delay in Young Children", 
    "DBT (Dialectical Behavior Therapy)",
    "TA (Transactional Analysis)",
    "Marriage Counseling",
    "Family Therapy"
  ],

  services: [
    {
      id: 1,
      title: "Individual Counseling",
      description: "Personal therapy sessions focused on your unique mental health needs and goals.",
      features: [
        "One-on-one sessions",
        "Personalized treatment plans", 
        "Evidence-based approaches",
        "Progress monitoring"
      ]
    },
    {
      id: 2,
      title: "Family Therapy",
      description: "Helping families improve communication, resolve conflicts, and strengthen relationships.",
      features: [
        "Family communication skills",
        "Conflict resolution techniques",
        "Relationship building",
        "Family dynamics understanding"
      ]
    },
    {
      id: 3,
      title: "Couples Counseling",
      description: "Supporting couples in building stronger, more connected relationships.",
      features: [
        "Communication improvement",
        "Relationship skills",
        "Conflict management",
        "Emotional connection"
      ]
    },
    {
      id: 4,
      title: "Teen & Adolescent Counseling",
      description: "Specialized support for teenagers and young adults navigating life challenges.",
      features: [
        "Adolescent development support",
        "Behavioral guidance",
        "Academic stress management",
        "Identity exploration"
      ]
    },
    {
      id: 5,
      title: "Clinical & Aptitude Testing", 
      description: "Comprehensive psychological assessments and testing services.",
      features: [
        "Psychological evaluations",
        "Aptitude assessments",
        "Diagnostic testing",
        "Treatment planning"
      ]
    },
    {
      id: 6,
      title: "De-addiction Programs",
      description: "Professional support for overcoming various forms of addiction.",
      features: [
        "Substance abuse counseling",
        "Behavioral addiction treatment",
        "Recovery planning",
        "Relapse prevention"
      ]
    }
  ],

  freePrograms: [
    {
      title: "Your Relationships",
      description: "Interactive talk/Q&A for couples or parents",
      format: "Group Workshop"
    },
    {
      title: "Emotional Wellness for Teens & Families", 
      description: "Skills for stronger bonds and better communication",
      format: "Family Program"
    },
    {
      title: "Stress Management & Resilience",
      description: "For busy professionals seeking balance and well-being",
      format: "Professional Workshop"
    }
  ],

  sessionTypes: [
    {
      type: "In-Person Sessions",
      location: "Lokhandwala Complex & Multiple Locations",
      note: "By prior appointment"
    },
    {
      type: "Online Sessions", 
      location: "Video Consultations",
      note: "For flexible access"
    }
  ],

  offer: {
    title: "Free 30-Minute Online Consultation",
    description: "Get started with a complimentary initial online consultation to discuss your needs and treatment options."
  }
};

export const mentalHealthInfo = {
  goodMentalHealth: {
    title: "Understanding Good Mental Health",
    description: "Mental health includes our emotional, psychological, and social well-being. It affects how we think, feel, and act. It also helps determine how we handle stress, relate to others, and make healthy choices. Maintaining good mental health is one of the best ways to prepare for life's difficult moments both at a personal and professional level."
  },
  
  causesOfPoorMentalHealth: [
    "Abuse and trauma",
    "Long-term stress or illness", 
    "Social rejection",
    "Death of loved ones",
    "Substance abuse",
    "Unhealthy lifestyle",
    "Relationship issues"
  ],

  therapySteps: [
    {
      step: 1,
      title: "Pre-assessment Session",
      description: "History taking, tests, and session planning"
    },
    {
      step: 2, 
      title: "Therapy & Counseling Sessions",
      description: "Sessions with fixed goals and targeted exercises"
    },
    {
      step: 3,
      title: "Follow-ups & Groups", 
      description: "Ongoing support and maintenance programs"
    }
  ],

  psychologistVsPsychiatrist: {
    psychologist: "Treats mental, emotional & psychological disorders through clinical therapies & counseling without medicines",
    psychiatrist: "Treats mental illness primarily through medication",
    collaboration: "Both complement each other for comprehensive care"
  }
};

// Contact form submission mock
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you soon." });
    }, 1000);
  });
};

// Appointment booking mock
export const bookAppointment = async (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Appointment booked:", appointmentData);
      resolve({ success: true, message: "Appointment request submitted successfully!" });
    }, 1000);
  });
};